import { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { isNull, isUndefined } from 'lodash'

import { VariableValue } from '@components/Variables/types'

import { getValuesFromVariables } from '@helpers'
import { ACTION_CODE, EVENT_CODE } from '@constants'
import { ActionRow, ObjectDataRecord, Row } from '@types'

export const useSetInitialValuesForFormFields = (
  outerVariables: VariableValue[],
  actions: ActionRow[],
  formMethods: UseFormReturn<Row>,
  defaultValues: ObjectDataRecord
) => {
  const { setValue } = formMethods

  const fieldsDefaultValues = useMemo(() => Object.keys(defaultValues), [defaultValues])

  const filteredActions = useMemo(
    () =>
      actions.filter(
        action =>
          action.actionCode === ACTION_CODE.SET_FIELD_VALUE &&
          fieldsDefaultValues.includes(action.objectFieldCode) &&
          action.jsValue &&
          action.eventCode === EVENT_CODE.ON_INIT_FORM
      ),
    [actions, fieldsDefaultValues]
  )

  const transformedVariables = useMemo(
    () => getValuesFromVariables(outerVariables),
    [outerVariables]
  )

  const srcObj = useMemo(() => ({ outerVariables: transformedVariables }), [transformedVariables])

  const isSetInitialValues = useMemo(() => {
    return filteredActions.length > 0
  }, [filteredActions])

  const setInitialValuesForFormFields = () => {
    filteredActions.forEach(action => {
      if (!action.jsValue) return

      const initValueField = new Function('srcObj', action.jsValue)(srcObj)

      if (isUndefined(initValueField) || isNull(initValueField)) return

      setValue(action.objectFieldCode, initValueField, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      })
    })
  }

  return { setInitialValuesForFormFields, isSetInitialValues }
}
